import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import { UserConfigContext } from "../../context/UserConfigContext";
import Swal from "sweetalert2";

const Profile = () => {
  const { config1, config2 } = useContext(UserConfigContext);
  const [GeneraPresupuesto, setGeneraPresupuesto] = useState(0);
  const [user, setUser] = useState(null);
  const [client, setClient] = useState(null);
  const [logo, setLogo] = useState(null); // Estado para la imagen
  const navigate = useNavigate();

  useEffect(() => {
    const loggedUserData = JSON.parse(localStorage.getItem("user"));
    // console.log(config2.vista.genera_presupuesto);

    if (loggedUserData && loggedUserData.data && loggedUserData.data.user) {
      setUser(loggedUserData.data.user);
      setClient(loggedUserData.data.cliente);
      setLogo(loggedUserData.data.cliente.url_logo); // Inicializamos la imagen
      setGeneraPresupuesto(config2.vista.genera_presupuesto || 0);
    } else {
      navigate("/signin");
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    navigate("/signin");
  };

  const handleNavigateHome = () => {
    navigate("/");
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setLogo(ev.target.result); // Actualiza la vista previa
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleSave = async () => {
    try {
      const body = {
        empresa: "51",
        operador: user.id,
        accion: "masivo",
        cliente: {
          nrocli: client.nrocli,
          nombre: client.nombre,
          nombre_fantasia: client.nombrefantasia,
          direccion: client.direccion,
          localidad: client.Localidad,
          pcia: client.Pcia,
          pais: client.id_pais,
          codigo_postal: client.Cod_post,
          telefono: client.telefono,
          telefono2: "",
          telefono3: "",
          email: client.email,
          cond_iva: client.cond_iva,
          moneda: client.moneda,
          tipo_doc: client.tipo_doc,
          cuit: client.cuit,
          fee: client.fee,
          dias_venc_presup: client.dias_venc_presup,
          vista_ecommerce: client.vista_ecommerce,
          ruta_logo: client.logo,
          logo_cliente: logo
        },
      };

      const response = await fetch(
        `${process.env.REACT_APP_URL_APIHN24}/clientes`,
        {
          method: "POST",
          headers: {
            Authorization:
              "Basic " +
              btoa("hinetService:99RHinet202"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      const data = await response.json();

      if (!response.ok || data.error) {
        throw new Error(data.message);
      }

      Swal.fire({
        icon: "success",
        title: "OK",
        text: "Cliente actualizado correctamente",
      });

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    }
  };

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Profile" />
      <div className="pb-10 text-center">
        {user ? (
          <>
            <h2 className="text-4xl font-bold mb-6">
              Bienvenido, {user.nombre}!
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
              <label className="block">
                <span className="font-semibold">Nombre</span>
                <input
                  type="text"
                  value={client.nombre}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="">
                <span className="font-semibold">Nombre Fantasia</span>
                <input
                  type="text"
                  value={client.nombrefantasia}
                  className="border p-2 w-full bg-gray-100"
                />
              </label>

              <label className="block">
                <span className="font-semibold">CUIT</span>
                <input
                  type="text"
                  value={client.cuit}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Email</span>
                <input
                  type="email"
                  value={client.email}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>


              <label className="block">
                <span className="font-semibold">Dirección</span>
                <input
                  type="text"
                  value={client.direccion}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Código Postal</span>
                <input
                  type="text"
                  value={client.Cod_post}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Teléfono</span>
                <input
                  type="text"
                  value={client.telefono}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Provincia</span>
                <input
                  type="text"
                  value={client.Pcia}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">Localidad</span>
                <input
                  type="text"
                  value={client.Localidad}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>

              <label className="block">
                <span className="font-semibold">País</span>
                <input
                  type="text"
                  value={client.id_pais}
                  className="border p-2 w-full bg-gray-100 cursor-not-allowed"
                />
              </label>
              {Number(GeneraPresupuesto) === 1 && (
                <>
                  <label className="block">
                    <span className="font-semibold text-lg">
                      Fee Precio
                    </span>
                    <p className="text-sm text-blue-600 mb-2">
                      (Incremento para Presupuestos)
                    </p>
                    <input
                      type="number"
                      value={client.fee || 0}
                      onChange={(e) =>
                        setClient({
                          ...client,
                          fee: e.target.value,
                        })
                      }
                      className="border p-3 w-full rounded-md"
                    />
                  </label>

                  <label className="block">
                    <span className="font-semibold text-lg">
                      Dias Vencimiento Presupuesto
                    </span>
                    <p className="text-sm text-blue-600 mb-2">
                      (Calcula Vencimiento Presupuestos)
                    </p>
                    <input
                      type="number"
                      value={client.dias_venc_presup || 0}
                      onChange={(e) =>
                        setClient({
                          ...client,
                          dias_venc_presup: e.target.value,
                        })
                      }
                      className="border p-3 w-full rounded-md"
                    />
                  </label>

                  <label className="block">
                    <span className="font-semibold text-lg">
                      Vista
                    </span>

                    <p className="text-sm text-blue-600 mb-2">
                      (Como se verá el ecommerce)
                    </p>

                    <select
                      value={client.vista_ecommerce || "tabla"}
                      onChange={(e) =>
                        setClient({
                          ...client,
                          vista_ecommerce: e.target.value,
                        })
                      }
                      className="border p-3 w-full rounded-md"
                    >
                      <option value="table">Tabla</option>
                      <option value="grid">Grilla</option>
                    </select>
                  </label>

                  <label className="block">
                    <span className="font-semibold text-lg">
                      Logo
                    </span>
                    <p className="text-sm text-blue-600 mb-2">
                      (Para Presupuesto)
                    </p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="border p-2 w-full"
                    />
                    {logo && (
                      <img
                        src={logo}
                        alt="Logo"                   
                        className="mt-2 w-32 h-32 object-contain border"
                      />
                    )}
                  </label>
                </>
              )}
            </div>

            <div className="mt-6">
              <button
                onClick={handleNavigateHome}
                className="w-40 h-10 bg-primeColor text-white text-lg hover:bg-black duration-300 mr-4"
              >
                Inicio
              </button>

              <button
                onClick={handleSave}
                className="w-40 h-10 bg-green-600 text-white text-lg hover:bg-green-700 duration-300 mr-4 rounded"
              >
                Grabar
              </button>

              <button
                onClick={handleLogout}
                className="w-40 h-10 bg-primeColor text-white text-lg hover:bg-black duration-300"
              >
                Cerrar sesión
              </button>
            </div>
          </>
        ) : (
          <p>Cargando...</p>
        )}
      </div>
    </div>
  );
};

export default Profile;
